export interface User {
  id: string
  email: string
  firstName?: string
  lastName?: string
  createdAt: string
  updatedAt: string
}

export interface Work {
  id: string
  userId: string
  title: string
  type: WorkType
  content: string
  wordCount: number
  status: WorkStatus
  createdAt: string
  updatedAt: string
  submissions?: Submission[]
}

export enum WorkType {
  POEM = 'poem',
  SHORT_STORY = 'short_story',
  ESSAY = 'essay',
  NOVEL = 'novel',
  FLASH_FICTION = 'flash_fiction'
}

export enum WorkStatus {
  DRAFT = 'draft',
  READY = 'ready',
  SUBMITTED = 'submitted',
  PUBLISHED = 'published'
}

export interface Journal {
  id: string
  name: string
  description?: string
  website?: string
  submissionEmail?: string
  acceptedTypes: WorkType[]
  responseTime?: number
  paymentRate?: string
  isActive: boolean
  createdAt: string
  updatedAt: string
  readingPeriods?: ReadingPeriod[]
}

export interface ReadingPeriod {
  id: string
  journalId: string
  startDate: string
  endDate: string
  isOpen: boolean
  acceptedTypes?: WorkType[]
  specialNotes?: string
}

export interface Submission {
  id: string
  userId: string
  workId: string
  journalId: string
  status: SubmissionStatus
  submittedAt: string
  responseDate?: string
  responseType?: ResponseType
  notes?: string
  followUpDate?: string
  createdAt: string
  updatedAt: string
  work?: Work
  journal?: Journal
}

export enum SubmissionStatus {
  SUBMITTED = 'submitted',
  UNDER_REVIEW = 'under_review',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  WITHDRAWN = 'withdrawn'
}

export enum ResponseType {
  ACCEPTANCE = 'acceptance',
  REJECTION = 'rejection',
  HOLD = 'hold',
  REQUEST_REVISIONS = 'request_revisions'
}

export interface DashboardStats {
  totalWorks: number
  activeSubmissions: number
  acceptances: number
  rejections: number
  openReadingPeriods: number
}